<template>
  <div>
    <v-text-field
      v-bind="fieldProps"
      v-on="forwardedListeners"
      :id="id"
      :value="inputValue"
      :label="computedLabel"
      :disabled="disabled"
      :hide-details="hideDetails"
      :append-icon="appendIcon"
      :min="computedMin"
      :max="computedMax"
      type="date"
      @input="onInput"
      @change="onChange"
      @click:append="clearValue"
    />
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<script>
import src from './src'
export default src
</script>
